import { AppPage } from "jk-service";
import { Mtrki01BillComponent } from "./mtrki01/mtrki01BillPkg.component";
import { Mtrki02BillComponent } from "./mtrki02/mtrki02BillPkg.component";
import { Mtrki04DetailComponent } from "./mtrki04/mtrki04-detail.component";
import { Mtrki04Component } from "./mtrki04/mtrki04.component";
import { Mtrkr03Component } from "./mtrkr03/mtrkr03.component";
import { Routes } from "@angular/router";
import { Mtrpi01BillComponent } from "./mtrpi01/mtrpi01BillPkg.component";
import { Mtrki03Component } from "./mtrki03/mtrki03.component";

export const mtrPages: AppPage[] = [
  {
    title: '工作清單',
    url: '/mtr/mtrki01',
    icon: '',
    id: 'mtrki01',
    isCheckPower: true,
  },
  {
    title: '問題反應單',
    url: '/mtr/mtrki02',
    icon: '',
    id: 'mtrki02',
    isCheckPower: true,
  },
  {
    title: '時間線記事',
    url: '/mtr/mtrki03',
    icon: '',
    id: 'mtrki03',
    isCheckPower: true,
  },
  {
    title: 'todo手機',
    url: '/mtr/mtrki04',
    id: 'mtrki04',
    icon: '',
    isCheckPower: true,
  },
  {
    title: '工作清單報表',
    url: '/mtr/mtrkr03',
    id: 'mtrkr03',
    icon: '',
    isCheckPower: true,
  },
  {
    title: '網址建立',
    url: '/mtr/mtrpi01',
    icon: '',
    id: 'mtrpi01',
    isCheckPower: true,
  },

];

export const mtrRoutes: Routes = [
  {
    path: 'mtrki01',
    component: Mtrki01BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  { path: 'mtrki02', component: Mtrki02BillComponent, },
  { path: 'mtrki03', component: Mtrki03Component, },
  { path: 'mtrki03a', component: Mtrki03Component, },
  { path: 'mtrki04', component: Mtrki04Component, },
  {
    path: 'mtrpi01',
    component: Mtrpi01BillComponent,
    //loadChildren: () => import('./mtrpi01/mtrpi01BillPkg.component').then(r => r.Mtrpi01BillComponent),
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'mtrkr03',
    component: Mtrkr03Component,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'mtrpi01',
    //loadChildren: () => import('./mtrpi01/mtrpi01.routes').then(m => m.MTRPI01_ROUTES)
    component: Mtrpi01BillComponent,
  },
];
